import { STORAGE_KEYS } from "../constants/keys";

// Reads back the "trust this device" token issued after a previous MFA
// code verification, if any — sent on subsequent /authorize calls so this
// device can skip the code screen within its trust window.
export const readDeviceTrustToken = (): string | null =>
  localStorage.getItem(STORAGE_KEYS.DEVICE_TRUST_TOKEN);

export const storeDeviceTrustToken = (token: string) => {
  if (token) localStorage.setItem(STORAGE_KEYS.DEVICE_TRUST_TOKEN, token);
};
